import React from 'react';
import NotificationItem from './NotificationItem';

const NotificationList = ({ notifications, filter, sortOrder }) => {
  let filteredNotifications = [...(notifications || [])]; // Use an empty array if notifications is null

  // Function to convert date string to Date object
  const parseDate = (dateStr) => new Date(dateStr.replace(' · ', ' '));

  if (filter) {
    filteredNotifications = filteredNotifications.filter((notification) =>
      notification.notification_name.toLowerCase().includes(filter.toLowerCase())
    );
  }

  // Separate unread and read notifications
  const unreadNotifications = filteredNotifications.filter((n) => n.active);
  const readNotifications = filteredNotifications.filter((n) => !n.active);

  // Sort unread notifications from newest to oldest
  unreadNotifications.sort((a, b) => parseDate(b.time) - parseDate(a.time));

  // Sort read notifications from newest to oldest
  readNotifications.sort((a, b) => parseDate(b.time) - parseDate(a.time));

  // Combine unread and read notifications (unread first)
  const sortedNotifications = [...unreadNotifications, ...readNotifications];

  // Function to group notifications by date
  const groupByDate = (notifications) => {
    return notifications.reduce((acc, notification) => {
      const date = parseDate(notification.time);
      const formattedDate = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(notification);
      return acc;
    }, {});
  };

  // Group all notifications by date
  const groupedNotifications = groupByDate(sortedNotifications);

  // Function to render grouped notifications with date labels
  const renderGroupedNotifications = (groupedNotifications) => {
    const dates = Object.keys(groupedNotifications)
    .map(dateStr => new Date(dateStr))  // Convert date strings to actual Date objects
    .sort((a, b) => b - a)              // Sort by most recent to oldest
    .map(dateObj => dateObj.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })); // Convert back to strings

    return dates.map((date) => (
      <div key={date}>
        {/* Skip current day's date */}
        {date !== new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) && (
          <div className="flex items-center my-4">
            <hr className="flex-grow border-t border-gray-300" />
            <span className="mx-4 text-gray-500">{date}</span>
            <hr className="flex-grow border-t border-gray-300" />
          </div>
        )}
        {groupedNotifications[date].map((notification) => (
          <NotificationItem key={notification._id} notification={notification} />
        ))}
      </div>
    ));
  };

  return (
    <div>
      {renderGroupedNotifications(groupedNotifications)}
    </div>
  );
};

export default NotificationList;
